<div
  [ngClass]="{
    loadingDone: status == success,
    loadingFailed: status == failed
  }"
>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    viewBox="0 0 37 37"
  >
    <path
      class="path"
      d="M30.5,6.5L30.5,6.5c6.6,6.6,6.6,17.4,0,24l0,0c-6.6,6.6-17.4,6.6-24,0l0,0c-6.6-6.6-6.6-17.4,0-24l0,0C13.1-0.2,23.9-0.2,30.5,6.5z"
    />

    <path
      class="second-layer"
      #secondLayer
      d="M30.5,6.5L30.5,6.5c6.6,6.6,6.6,17.4,0,24l0,0c-6.6,6.6-17.4,6.6-24,0l0,0c-6.6-6.6-6.6-17.4,0-24l0,0C13.1-0.2,23.9-0.2,30.5,6.5z"
    />

    <polyline class="success" points="11.6,20 15.9,24.2 26.4,13.8 " />

    <polyline class="failed right" points="10,27 26.4,10 "></polyline>
    <polyline class="failed left" points="26.4,27 10,10 "></polyline>
  </svg>
</div>
